<template>
  <div class="report-card-box" @click="read(url)">
    <div class="report-date">
      <div>
        <img src="@/assets/image/btcinfo/report/pdf.png" alt="pdf">
        <div>{{ year }}</div>
      </div>
      <div>{{ date }}</div>
    </div>
    <div class="report-title">
      <div>
        {{ title }}
      </div>
    </div>
    <div class="report-download hand" @click.stop="download(url)">
      <img src="@/assets/image/btcinfo/report/download.png" alt="download">
      <div>Download</div>
    </div>
    <div class="report-read hand">
      <div>Read</div>
      <div>></div>
    </div>
    <div v-if="data.BulletinID === 999" class="free">Free</div>
  </div>
</template>

<script>
import commonmix from '@/utils/commonmix'

export default {
  mixins: [commonmix],
  name: 'BTCInfoReportCard',
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    isEnExpire: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      title: 'BTC Report'
    }
  },
  computed: {
    year () {
      return this.data.BulletinTitle.slice(11, 15)
    },
    date () {
      return this.data.BulletinTitle.slice(16, 27)
    },
    url () {
      return process.env.VUE_APP_STATIC + this.data.BulletinPath
    }
  },
  methods: {
    download (href) {
      if (this.$store.getters.token) {
        if (this.isEnExpire || this.data.BulletinID === 999) {
          fetch(href).then((response) => {
            return response.blob()
          }).then((arraybuffer) => {
            const blob = new Blob([arraybuffer])
            const link = document.createElement('a')
            const fileName = new Date().getTime() + '.pdf'
            link.href = window.URL.createObjectURL(blob)
            link.download = fileName
            link.click()
            window.URL.revokeObjectURL(link.href)
          })
        } else {
          this.openMembershipModal()
        }
      } else {
        this.openLoginModal()
      }
    },
    read (url) {
      if (this.$store.getters.token) {
        if (this.isEnExpire || this.data.BulletinID === 999) {
          window.open(url)
        } else {
          this.openMembershipModal()
        }
      } else {
        this.openLoginModal()
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.report-card-box {
  width: 353px;
  height: 106px;
  border-radius: 8px;
  background-image:url(../../../../assets/image/btcinfo/report/background.png);
  background-repeat: no-repeat;
  background-size: cover;
  box-shadow: 2px 2px 5px 2px #e0e0e0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 80px 0 10px;
  position: relative;
}

.report-date > div:first-child {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px 0;
  font-size: 20px;
  font-weight: bold;
}

.report-date > div:first-child > img {
  width: 12px;
  height: 16px;
  margin-right: 10px;
}

.report-date > div:last-child {
  font-size: 14px;
  font-weight: bold;
}

.report-title {
  color: #014479;
  font-size: 20px;
  font-weight: bold;
}

.report-download {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #014479;
  font-size: 10px;
  position: absolute;
  bottom: 0;
  right: 90px;
}

.report-download > img {
  width: 12px;
  height: 10px;
  margin-right: 5px;
}

.report-read {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #DF232A;
  font-size: 10px;
  position: absolute;
  bottom: 10px;
  right: 5px;
}

.report-read > div:first-child {
  margin-right: 5px;
}

.free {
  position: absolute;
  font-size: 12px;
  background: #e32229;
  border-radius: 3px 8px 3px 3px;
  color: #ffffff;
  padding: 0 5px;
  top: 0;
  right: 0;
}
</style>
